// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1kP6I","label":"Completed_label__2KIFM"};